import React, { useState, useEffect } from 'react';

import ScreenBlock from '../Screen/ScreenBlock';
import Loader from '../UI/Loader';
import Filter from './Filter';
import FindRoundtripTable from './FindRoundtripTable';

const FindRoundtrips = (props) => {
  const [filter, setFilter] = useState(0);
  const [active, setActive] = useState(0);
  const [inActive, setInactive] = useState(0);
  const [roundtrips, setRoundtrips] = useState([]);

  const { OFFERS } = props;
  // Handle setting roundtrip state
  useEffect(() => {
    if (OFFERS && OFFERS[4].findRoundtrips && OFFERS[4].findRoundtrips?.length > 0) {
      setRoundtrips(OFFERS[4].findRoundtrips);
    }
  }, [OFFERS]);

  // Reset filter when there are no roundtrips to show
  useEffect(() => {
    if (roundtrips?.length <= 0 && filter > 0) {
      setFilter(0);
      setRoundtrips(OFFERS[1].roundtrips);
    }
  }, [roundtrips, filter, OFFERS]);

  // Get count of active and inactive roundtrips
  useEffect(() => {
    if (OFFERS && OFFERS[4].findRoundtrips) {
      setActive(0);
      setInactive(0);
      OFFERS[4].findRoundtrips.forEach((e) =>
        e.active
          ? setActive((prevCount) => prevCount + 1)
          : setInactive((prevCount) => prevCount + 1)
      );
    }
  }, [OFFERS]);

  // Handle roundtrip filtering
  useEffect(() => {
    if (filter === 0 && OFFERS) {
      setRoundtrips(OFFERS[4].findRoundtrips);
    } else if (filter === 1) {
      setRoundtrips(OFFERS[4].findRoundtrips.filter((e) => e.active));
    } else if (filter === 2) {
      setRoundtrips(OFFERS[4].findRoundtrips.filter((e) => !e.active));
    }
  }, [OFFERS, filter]);

  // Display welcome mat when no roundtrips to show
  if (OFFERS && OFFERS[4].findRoundtrips && OFFERS[4].findRoundtrips <= 0) {
    return null;
  }

  return (
    <ScreenBlock title="Roundtrip Requests">
      {roundtrips.length > 0 && (
        <Filter
          all={OFFERS && OFFERS[1]?.roundtrips?.length}
          active={active}
          inActive={inActive}
          filter={filter}
          setFilter={setFilter}
          type="Find rountrip"
          to="/dashboard/find-roundtrips/create"
          isExpired={props.isExpired}
          setExpiredModal={props.setExpiredModal}
          isRegular={props.isRegular}
          setRegularModal={props.setRegularModal}
        />
      )}
      {roundtrips.length > 0 ? (
        <FindRoundtripTable
          roundtrips={roundtrips}
          handleStatusChange={props.handleStatusChange}
          handleOfferRemove={props.handleOfferRemove}
        />
      ) : (
        <Loader />
      )}
    </ScreenBlock>
  );
};

export default FindRoundtrips;
